import toast from "react-hot-toast";
import { baseUrl } from "./baseUrl";

export async function deletePayment(id: string): Promise<void> {
  const token = sessionStorage.getItem("admin_token");
  try {
    const res = await fetch(
      `${baseUrl}/admin/payments/${id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!res.ok) {
      const err = await res.json().catch(() => null);
      const msg = err?.message?.toLowerCase?.() ?? "";
      if (["invalid token", "jwt malformed", "jwt expired"].includes(msg)) {
        sessionStorage.removeItem("admin_token");
        toast.error("Session expired, please sign in again.");
        window.location.href = "/auth/sign-in";
        return Promise.reject(new Error("Unauthorized"));
      }
      throw new Error(err?.message ?? `HTTP ${res.status}`);
    }

    toast.success("Payment deleted");
  } catch (error) {
    console.error("Error deleting payment:", (error as Error).message);
    toast.error(`Delete failed: ${(error as Error).message}`);
    throw error;
  }
}
